import type {
  MLMachineSummary,
  MLProcessSummary,
  MLToolSummary,
  MLInferenceRequest,
  MLInferenceJobResult,
} from '../type/MLTypes';
import type { HttpClient } from '@/lib/http/HttpClient';

import * as mockImpl from './MLApiClient.mock';
import * as realImpl from './MLApiClient.real';

// All three catalog endpoints (machines, processes, tools) are wired to tracabilite_storage.
// Real backend calls by default; set VITE_ML_USE_MOCK=true to use the hard-coded mock catalog.
// Inference: real orchestrator route (POST /api/machine-learning/predict/regression-xgb-full) by default.
// Set VITE_ML_INFERENCE_USE_MOCK=true to use the simulated job flow instead.
const catalogImpl = import.meta.env.VITE_ML_USE_MOCK === 'true' ? mockImpl : realImpl;
const inferenceImpl = import.meta.env.VITE_ML_INFERENCE_USE_MOCK === 'true' ? mockImpl : realImpl;
// Signal fetching moved to the signals feature — see
// @/features/signals/api/SignalsApiClient (own VITE_ML_SIGNAL_USE_MOCK flag).

export function mlListMachines(http?: HttpClient): Promise<MLMachineSummary[]> {
  return catalogImpl.mlListMachines(http);
}

export function mlListProcesses(machineId: number, http?: HttpClient): Promise<MLProcessSummary[]> {
  return catalogImpl.mlListProcesses(machineId, http);
}

export function mlListToolsForProcess(processId: number, toolReference: string, http?: HttpClient): Promise<MLToolSummary[]> {
  return catalogImpl.mlListToolsForProcess(processId, toolReference, http);
}

export function mlSubmitInference(req: MLInferenceRequest, http?: HttpClient): Promise<{ jobId: string }> {
  return inferenceImpl.mlSubmitInference(req, http);
}

export function mlGetInferenceStatus(jobId: string): Promise<MLInferenceJobResult> {
  return inferenceImpl.mlGetInferenceStatus(jobId);
}
